<template>
  <aside
    class="w-56 p-4 space-y-1 border-r border-gray-200 bg-white shrink-0 relative z-20"

    :class="!loading && 'disable-ske'"
  >
    <ul v-if="loading" role="list">
      <PageItem
        v-for="name in placeholder"
        :name="name"
        :key="name"
        :loading="loading"
      />
    </ul>
    <ul v-else role="list">
      <PageItem
        v-for="item in pages"
        v-bind="item"
        :selected="item.uid === selected"
        :loading="loading"

        :key="item.uid || item.name"
        @save="newName => savePage(item, newName)"
        @delete="deletePage(item)"
        @select="selected = item.uid"
      />

      <PageItem key="page-adder"
        :adder="true"
        @save="addNewPage"
      />
    </ul>
  </aside>
</template>

<script>

import { mapGetters } from "vuex"
import queryParameters from "@/mixins/queryParameters"

import PageItem from "./PageItem.vue"

export default {
  mixins: [queryParameters(['selected'])],
  components: {
    PageItem,
  },
  created() {
    this.$emit('provide-page', this.selected)
    this.fetchPages()
  },
  data() {
    return {
      loading: false,
      pages: [],
      placeholder: ['ashtthssht', 'ashtasht ashtasht', 'ashththt', 'asthatatast ashta ht', 'wrddthstshtst'],
      selected: null,
    }
  },
  methods: {
    async addNewPage(name) {
      try {
        this.pages.push({name})
        this.ensureSort()
        await this.axios.post(`/api/websites/${this.websiteUid}/pages`, { name, type: 'page' })
        this.$store.dispatch('clearCacheSearch', "websites")
        this.ensureSort()
        await this.fetchPages(true)
      } catch (err) {
        await this.$store.dispatch('toast/handleError', err)
        await this.fetchPages()
      }
    },
    async savePage(item, newName) {
      try {
        this.pages.splice(
          this.pages.findIndex(page => item.uid === page.uid),
          1,
          { name: newName, uid: item.uid }
        )

        this.ensureSort()
        await this.axios.put(`/api/websites/${this.websiteUid}/pages/${item.uid}`, { name: newName, type: 'page' })
        this.$store.dispatch('clearCacheSearch', "websites")
        this.ensureSort()
        await this.fetchPages(true)
      } catch (err) {
        await this.$store.dispatch('toast/handleError', err)
        await this.fetchPages()
      }
    },
    async deletePage({ uid, name }) {
      this.$store.dispatch('toast/warning', {
        message: `Are you sure you want to the delete the ${name} page?`,
        description: "This action cannot be undone.",

        confirm: {
          confirmMessage: "Delete",
          cancelMessage: "Cancel",

          onConfirm: async () => {
            try {
              this.pages.splice(
                this.pages.findIndex(page => uid === page.uid),
                1,
              )

              this.ensureSort()
              await this.axios.delete(`/api/websites/${this.websiteUid}/pages/${uid}`)
              this.$store.dispatch('clearCacheSearch', "websites")
              this.ensureSort()
              await this.fetchPages(true)
            } catch (err) {
              await this.$store.dispatch('toast/handleError', err)
              await this.fetchPages()
            }
          },
        },
      })
    },
    ensureSort() {
      const pages = this.pages.slice()
      pages.sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()))
      this.pages = pages
    },

    async fetchPages(removeLoading = false) {
      this.loading = !removeLoading
      const pages = (await this.axios.get(`/api/websites/${this.websiteUid}/pages`)).data.results
      this.pages = pages.filter(page => page.name !== "404")
      this.ensureSort()
      if (!this.selected && this.pages[0]) this.selected = this.pages[0].uid
      this.loading = false
    },
  },
  computed: {
    ...mapGetters({
      websiteUid: 'editor/websiteUid',
    }),
  },
  watch: {
    selected() {
      this.$emit('provide-page', this.selected)
    },
  },
}

</script>
